import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from 'screens/components/basic/Button';
import GenericTable from 'screens/components/advanced/GenericTable';
import LOOKUP from 'constants/lookup';
import { Link } from 'react-router-dom';
import { getactiveEmployeesOfBranch, getShiftsFilter } from 'actions/EntityActions';
import { formInput, clearFormInput } from 'actions/FormActions';
import Pagination from 'screens/components/basic/Pagination';
import Grid from 'screens/components/basic/Grid';
import SearchFields from './searchFields';
import { shiftListCrumb } from 'utils/breadcrumbInfo';
import moment from 'moment';
import CardSimple from 'screens/components/basic/CardSimple';
import WithRouter from 'custom/withRouter';
import PageHeaderWithButton from 'screens/components/basic/PageHeaderWithButton';

class ShiftList extends Component {
    constructor(props) {
        super(props);
        this.getShiftList = this.getShiftList.bind(this);

        this.state = {
            activePage: 1,
            itemsPerPage: 40,
            orderBy: "DESC",
            sortBy: "PunchInDate"
        };

        this.sort = this.sort.bind(this);
    }

    componentWillMount = () => {
        const date = new Date();
        const model = {
            branchId: parseInt(localStorage.getItem('TECHPOS_SELECTED_BRANCH'))
        }
        this.props.getactiveEmployeesOfBranch(model);
        this.props.beginDate || this.props.formInput(new Date(date.getFullYear(), date.getMonth(), 1), `shiftListBeginDateFilter`);
        this.props.endDate || this.props.formInput(date, `shiftListEndDateFilter`);
    }

    componentDidMount = () => {
        this.getShiftsFilter();
    }

    componentWillUnmount = () => {
        this.cleanSearch();
    }

    goEditShiftPage = (employeeId, date, status) => {
        this.props.navigate(`/admin/shift/edit/${employeeId}/${date}/${status}`);
    }

    cleanSearch = () => {
        this.props.clearFormInput('shiftListEmployeeFilter');
        this.props.clearFormInput('shiftListFirstNameFilter');
        this.props.clearFormInput('shiftListLastNameFilter');
        this.props.clearFormInput('shiftListBeginDateFilter');
        this.props.clearFormInput('shiftListEndDateFilter');
        this.props.clearFormInput('shiftListEmployeeList');
        this.props.clearFormInput('shiftListStatus');
        this.props.clearFormInput('shiftListShowEmployees');

        this.setState(pState => {
            return {
                ...pState,
                activePage: 1,
                sortBy: "PunchInDate",
                orderBy: "DESC"
            };
        }, () => this.getShiftsFilter());
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getShiftsFilter);
    }

    search = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getShiftsFilter);
    }

    getShiftsFilter = () => {
        const model = {
            page: this.state.activePage,
            itemsPerPage: this.state.itemsPerPage,
            beginDate: this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().startOf('month').format('MM-DD-YYYY'),
            endDate: this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY'),
            employeeIds: (this.props.employeeFilter || "").toString(),
            firstName: this.props.shiftEmployeeFirstName || "",
            lastName: this.props.shiftEmployeeLastName || "",
            status: this.props.shiftStatus || "None",
            orderBy: this.state.orderBy,
            sortBy: this.state.sortBy,
            branchId: parseInt(localStorage.getItem('TECHPOS_SELECTED_BRANCH'))
        };

        this.props.getShiftsFilter(model);
    }

    getShiftList = () => {
        return this.props.shifts.map((item, index) => {
            return {
                EmployeeFirstName: item.employeeFullName,
                PunchInDate: item.punchInDate,
                Status: item.status,
                Icon: <Button
                    type="IconEditButton"
                    id={`buttonEditShift-${index}`}
                    mini={true}
                    onTouchTap={() => this.goEditShiftPage(item.employeeId, item.punchInDate, item.status)} />
            };
        });
    };

    sort(sortBy) {
        this.setState(prevState => {
            return {
                ...prevState,
                orderBy: prevState.orderBy === 'DESC' ? 'ASC' : 'DESC',
                sortBy: sortBy
            }
        }, this.getShiftsFilter);
    }

    render() {
        const p = this.props;
        const s = this.state;
        const header = (
            <div>
                <ol className="breadcrumb">
                    <li><Link to={LOOKUP.menu.home.link}>{LOOKUP.menu.home.text}</Link></li>
                    <li className="active">{LOOKUP.menu.admin.items.shiftList.text}</li>
                </ol>
                <h2 className="purpleText">{LOOKUP.menu.admin.items.shiftList.text}</h2>
            </div>
        );

        const employeeOptions = p.employeeList.map(item => {
            return {
                text: `${item.firstName} ${item.lastName}`,
                value: item.id.toString()
            };
        });


        return (
            <Grid headerContent={shiftListCrumb}>
                <PageHeaderWithButton title={LOOKUP.shiftList.listTitle}>
                    <Button
                        type="AddButton"
                        mini={true}
                        label="ADD NEW SHIFT"
                        className="bg-light-green"
                        onTouchTap={() => this.props.navigate("/admin/shift/add")} />
                </PageHeaderWithButton>
                <CardSimple className="p-1">
                    <SearchFields cleanSearch={this.cleanSearch} search={this.search} employeeOptions={employeeOptions} isShowList={this.props.showEmployeeList} />
                </CardSimple>
                <CardSimple>
                    <GenericTable
                        compName="shiftListTable"
                        multiSelectable={false}
                        enableSelectAll={false}
                        displaySelectAll={false}
                        adjustForCheckbox={false}
                        displayRowCheckbox={false}
                        selectable={true}
                        columns={LOOKUP.shiftList.tableColumns}
                        rows={this.getShiftList()}
                        orderBy={this.state.orderBy}
                        sortBy={this.state.sortBy}
                        sort={this.sort}
                        stripedRows={true}
                    />
                    <Pagination
                        length={p.shiftsListLength || 0}
                        itemsPerPage={s.itemsPerPage}
                        activePage={s.activePage}
                        onPageChange={(e) => this.changePage(e)}
                    />
                </CardSimple>
            </Grid>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        shifts: state.entity.shiftsListFilter,
        shiftsListLength: state.entity.shiftsListFilterLength,
        employeeList: state.entity.employeeList,
        beginDate: state.form['shiftListBeginDateFilter'] ? new Date(state.form['shiftListBeginDateFilter']) : null,
        endDate: state.form['shiftListEndDateFilter'] ? new Date(state.form['shiftListEndDateFilter']) : null,
        employeeFilter: state.form['shiftListEmployeeList'] || [],
        shiftEmployeeFirstName: state.form.shiftListFirstNameFilter,
        shiftEmployeeLastName: state.form.shiftListLastNameFilter,
        shiftStatus: state.form.shiftListStatus,
        showEmployeeList: state.form['shiftListShowEmployees']
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        getactiveEmployeesOfBranch: (model) => dispatch(getactiveEmployeesOfBranch(model)),
        getShiftsFilter: (model) => dispatch(getShiftsFilter(model)),
        formInput: (value, name) => dispatch(formInput(value, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(ShiftList));